import { createSlice } from "@reduxjs/toolkit";
import { userNormalLogout, supportLogout } from "../actions";

export interface DownloadReportsState {
  isFetchingReportsData: boolean;
  allDownloadedReports: any;
}

const initialState: DownloadReportsState = {
  isFetchingReportsData: false,
  allDownloadedReports: [],
};

export const downloadsSlice = createSlice({
  name: "downloads",
  initialState,
  reducers: {
    getAllDownloadsReport: (state) => {
      state.isFetchingReportsData = true;
    },
    saveAllDownloadsReport: (state, actions) => {
      state.allDownloadedReports = actions.payload;
      state.isFetchingReportsData = false;
    },
    sendEmailRequest: (state, actions) => {
      state.isFetchingReportsData = true;
    },
    saveEmailRequest: (state) => {
      state.isFetchingReportsData = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userNormalLogout, () => initialState)
      .addCase(supportLogout, () => initialState);
  },
});

export const {
  getAllDownloadsReport,
  saveAllDownloadsReport,
  sendEmailRequest,
  saveEmailRequest,
} = downloadsSlice.actions;
export default downloadsSlice.reducer;
